export const SESSION_LOGIN = 'SESSION_LOGIN'
export const SESSION_LOGOUT = 'SESSION_LOGOUT'
export const GET_ACCOUNT = 'GET_ACCOUNT'
export const TOGGLE_COLLAPSE_MENU = 'TOGGLE_COLLAPSE_MENU'
export const SET_PENDING_ACCOUNT_IDS = 'SET_PENDING_ACCOUNT_IDS'
export const SET_PENDING_CAMPAIGN_IDS = 'SET_PENDING_CAMPAIGN_IDS'

export const login = payload => dispatch =>
  dispatch({
    type: SESSION_LOGIN,
    payload: payload
  })
export const getAccount = payload => dispatch =>
  dispatch({
    type: GET_ACCOUNT,
    payload: payload
  })

export const logout = () => dispatch =>
  dispatch({
    type: SESSION_LOGOUT
  })

export const toggleCollapseMenu = () => dispatch =>
  dispatch({
    type: TOGGLE_COLLAPSE_MENU
  })

export const setPendingAccountIDs = payload => dispatch => {
  dispatch({
    type: SET_PENDING_ACCOUNT_IDS,
    payload: payload
  })
  localStorage.setItem('pendingAccountIDs', JSON.stringify(payload))
}
export const setPendingCampaignIDs = payload => dispatch => {
  dispatch({
    type: SET_PENDING_CAMPAIGN_IDS,
    payload: payload
  })
  localStorage.setItem('pendingCampaignIDs', JSON.stringify(payload))
}
